import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { mdiViewColumnOutline } from '@mdi/js';
import { Icon } from '@mdi/react';
import { Button } from '@mui/material';
import { Box } from '@mui/system';
import { useState, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { ColumnsSettingsDialog } from '../../../components/ColumnsSettingsDialog';
import { useSTColumnOrder } from '../../SmartTableContext';
const ConfigureColumnsButton = () => {
    const { shiftColumns } = useSTColumnOrder();
    const [showColumnFilterDialog, setShowColumnFilterDialog] = useState(false);
    const handleFilterDialogClose = useCallback(() => {
        setShowColumnFilterDialog(false);
        shiftColumns();
    }, [shiftColumns]);
    const handleFilterDialogOpen = useCallback(() => setShowColumnFilterDialog(true), []);
    return (_jsxs(_Fragment, { children: [_jsx(Box, { children: _jsx(Button, { size: "small", variant: "outlined", onClick: handleFilterDialogOpen, startIcon: _jsx(Icon, { path: mdiViewColumnOutline, size: 1 }), children: _jsx(FormattedMessage, { id: "table.configureColumns.button", defaultMessage: "Configure columns" }) }) }), _jsx(ColumnsSettingsDialog, { open: showColumnFilterDialog, onClose: handleFilterDialogClose })] }));
};
export default ConfigureColumnsButton;
//# sourceMappingURL=ConfigureColumnsButton.js.map